import ReactLoading from 'react-loading';

function FullPageLoading() {
    return (
        <div className="full">
            <div className="card game-select-card">
                <div className="game-select-card__post-wrapper">
                    <div className="loading-fullpage--content">
                        <div className="text-bubble">{'Načítání...'}</div>
                        <ReactLoading type="cubes" color="#23ab70" height={90} width={90} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FullPageLoading;
